export type MovieType = "电影" | "电视剧" | "综艺";

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  cover: string;
  banner?: string;
  synopsis: string;
  director: string;
  cast: string[];
  duration: string;
  tagline: string;
  featured?: boolean;
  heat: string;
}

export const movies: Movie[] = [
  {
    id: "m001",
    title: "深海回声",
    type: "电影",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20lone%20diver%20silhouette%20descending%20into%20a%20deep%20navy%20abyss%20with%20a%20single%20beam%20of%20amber%20light%20cutting%20through%20dark%20water%2C%20dramatic%20atmospheric%20fog%2C%20moody%20teal%20and%20gold%20color%20grading%2C%20high%20detail%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-deepsea-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20seascape%20at%20night%20with%20a%20deep%20navy%20ocean%20surface%2C%20glowing%20amber%20light%20rays%20piercing%20the%20darkness%2C%20tiny%20diver%20silhouette%2C%20misty%20atmospheric%20mood%2C%20dramatic%20film%20still%2C%20teal%20and%20warm%20gold%20color%20grading%2C%20no%20text&width=1600&height=900&seq=movie-deepsea-banner&orientation=landscape",
    synopsis: "一支深海科考队在万米海沟收到一段来源不明的声呐讯号，队长林澈带着队员下潜调查，却发现讯号里重复着十年前失踪队友的名字。随着氧气与时间一同耗尽，真相与海底的黑暗一起浮出水面。",
    director: "陆屿舟",
    cast: ["陈屿", "周意棠", "许牧", "顾岸"],
    duration: "118 分钟",
    tagline: "有些回声，只属于海底。",
    featured: true,
    heat: "9.8 万人正在看",
  },
  {
    id: "m002",
    title: "逆光追凶",
    type: "电影",
    year: 2025,
    region: "中国大陆",
    genres: ["犯罪", "悬疑", "动作"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20poster%20artwork%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20narrow%20rainy%20alley%20at%20dusk%2C%20strong%20backlight%20creating%20rim%20glow%2C%20wet%20asphalt%20reflections%2C%20deep%20navy%20shadows%20with%20orange%20street%20lamp%20glow%2C%20cinematic%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-backlight-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Rain%20soaked%20city%20street%20at%20night%20seen%20from%20a%20low%20angle%2C%20blurry%20silhouettes%20of%20a%20detective%20walking%20toward%20warm%20orange%20street%20lamps%2C%20deep%20navy%20blue%20sky%20and%20reflective%20wet%20pavement%2C%20cinematic%20thriller%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-backlight-banner&orientation=landscape",
    synopsis: "刑警顾川在追查一起连环失踪案时，发现所有线索都指向自己十年前未破的旧案。逆光而行的他必须在天亮之前，重新走一遍那条通向真相的暗巷。",
    director: "裴野",
    cast: ["肖渡", "沈知夏", "白砚", "程野"],
    duration: "126 分钟",
    tagline: "天亮之前，谁都有罪。",
    featured: true,
    heat: "12.4 万人正在看",
  },
  {
    id: "m003",
    title: "星轨之外",
    type: "电影",
    year: 2023,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20poster%20artwork%20of%20an%20astronaut%20floating%20beside%20a%20ringed%20planet%2C%20vast%20navy%20nebula%20backdrop%20with%20warm%20amber%20starlight%2C%20minimal%20composition%2C%20dramatic%20scale%20contrast%2C%20cinematic%20lighting%2C%20highly%20detailed%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-startrack-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Expansive%20science%20fiction%20landscape%20of%20a%20ringed%20planet%20rising%20above%20a%20rocky%20alien%20horizon%2C%20deep%20navy%20starfield%20with%20amber%20glow%20at%20the%20edge%20of%20the%20atmosphere%2C%20tiny%20figure%20of%20an%20astronaut%2C%20cinematic%20wide%20film%20still%2C%20no%20text&width=1600&height=900&seq=movie-startrack-banner&orientation=landscape",
    synopsis: "一艘漂流两百年的方舟在返航途中偏离星轨，领航员艾拉发现导航系统一直在改写他们的目的地。当船上的记忆开始互相矛盾，她必须决定：是回到故乡，还是驶向真正的人类新世界。",
    director: "Evan Cole",
    cast: ["Mia Hartley", "Noah Reed", "Ethan Vale"],
    duration: "142 分钟",
    tagline: "宇宙没有终点，只有选择。",
    featured: true,
    heat: "15.1 万人正在看",
  },
  {
    id: "m004",
    title: "长夜将尽",
    type: "电影",
    year: 2024,
    region: "英国",
    genres: ["剧情", "历史"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Moody%20historical%20drama%20poster%20artwork%20of%20a%20woman%20in%20a%20wool%20coat%20standing%20by%20a%20harbor%20at%20dawn%2C%20grey%20navy%20fog%2C%20warm%20amber%20lantern%20light%2C%20muted%20film%20grain%20texture%2C%20painterly%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-longnight-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Atmospheric%20harbor%20town%20at%20blue%20hour%20with%20old%20stone%20buildings%20and%20moored%20fishing%20boats%2C%20thick%20navy%20fog%20and%20a%20single%20warm%20amber%20lighthouse%20beam%2C%20historical%20drama%20film%20still%2C%20muted%20cinematic%20tones%2C%20no%20text&width=1600&height=900&seq=movie-longnight-banner&orientation=landscape",
    synopsis: "1944 年的北方港口，灯塔守夜人的女儿在空袭与流言之间守着一个秘密。长夜将尽时，她终于明白有些等待必须由自己结束。",
    director: "Arthur Finch",
    cast: ["Clara Wynn", "Thomas Hale", "Iris Doyle"],
    duration: "131 分钟",
    tagline: "天亮之前，先学会告别。",
    featured: true,
    heat: "6.2 万人正在看",
  },
  {
    id: "m005",
    title: "无间雪原",
    type: "电影",
    year: 2025,
    region: "中国大陆",
    genres: ["动作", "冒险"],
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Action%20adventure%20poster%20artwork%20of%20a%20lone%20rider%20on%20horseback%20crossing%20a%20vast%20snowfield%2C%20dark%20navy%20blue%20shadows%20and%20warm%20amber%20sunrise%20glow%2C%20distant%20mountain%20ridges%2C%20dramatic%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-snowfield-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sweeping%20snowfield%20at%20sunrise%20with%20long%20shadows%2C%20a%20horse%20rider%20silhouette%20in%20the%20distance%2C%20deep%20navy%20mountain%20silhouette%20against%20warm%20amber%20sky%2C%20cinematic%20wide%20shot%2C%20atmospheric%20haze%2C%20no%20text&width=1600&height=900&seq=movie-snowfield-banner&orientation=landscape",
    synopsis: "边境押运队在暴风雪中失联，退役骑手韩烈只身进入雪原寻找队伍，却发现这场风雪里藏着比寒冷更危险的人心。",
    director: "岳北",
    cast: ["雷澈", "叶知秋", "孟川"],
    duration: "110 分钟",
    tagline: "风雪之下，无人置身事外。",
    heat: "5.7 万人正在看",
  },
  {
    id: "m006",
    title: "雾都迷航",
    type: "电影",
    year: 2022,
    region: "中国香港",
    genres: ["犯罪", "悬疑"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Neo%20noir%20crime%20poster%20artwork%20of%20a%20man%20in%20a%20trench%20coat%20under%20a%20flickering%20neon%20sign%20in%20a%20foggy%20city%20alley%2C%20deep%20navy%20fog%20and%20amber%20neon%20reflections%20on%20wet%20ground%2C%20cinematic%20mystery%20mood%2C%20no%20text&width=600&height=900&seq=movie-fogcity-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Night%20city%20skyline%20swallowed%20by%20thick%20fog%2C%20scattered%20warm%20amber%20windows%20glowing%20through%20deep%20navy%20haze%2C%20cinematic%20wide%20aerial%20view%2C%20neo%20noir%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-fogcity-banner&orientation=landscape",
    synopsis: "一位出租车司机在雾夜载上最后一位乘客，乘客留下的一只旧皮包，把他卷进了一桩跨越二十年的悬案。",
    director: "麦子衡",
    cast: ["郑柏川", "梁若彤", "杜明"],
    duration: "104 分钟",
    tagline: "雾散的时候，别回头。",
    heat: "4.9 万人正在看",
  },
  {
    id: "m007",
    title: "夏日放映厅",
    type: "电影",
    year: 2024,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20romantic%20poster%20artwork%20of%20a%20small%20seaside%20cinema%20at%20dusk%20with%20warm%20amber%20marquee%20lighting%2C%20a%20couple%20silhouetted%20at%20the%20entrance%2C%20deep%20navy%20twilight%20sky%2C%20gentle%20film%20grain%2C%20cinematic%20Japanese%20summer%20mood%2C%20no%20text&width=600&height=900&seq=movie-summercinema-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Small%20vintage%20seaside%20cinema%20by%20a%20quiet%20street%20in%20summer%20twilight%2C%20warm%20amber%20signs%20glowing%20against%20deep%20navy%20sky%2C%20bicycles%20parked%20outside%2C%20soft%20nostalgic%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-summercinema-banner&orientation=landscape",
    synopsis: "海边小镇唯一一家老影院即将关门，暑期代班放映员与常来坐最后一排的女孩，用一整个夏天的电影完成了彼此的道别。",
    director: "小林透",
    cast: ["森川遥", "浅野凉", "山口澄"],
    duration: "112 分钟",
    tagline: "散场之后，夏天还在。",
    heat: "7.8 万人正在看",
  },
  {
    id: "m008",
    title: "荒原信使",
    type: "电影",
    year: 2023,
    region: "美国",
    genres: ["西部", "剧情"],
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Western%20drama%20poster%20artwork%20of%20a%20lone%20postman%20riding%20a%20horse%20across%20a%20dusty%20desert%20at%20golden%20hour%2C%20long%20shadow%2C%20deep%20navy%20distant%20mesa%20silhouettes%2C%20warm%20amber%20dust%20haze%2C%20cinematic%20western%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-wasteland-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20desert%20plain%20at%20golden%20hour%20with%20a%20rider%20and%20pack%20horse%20crossing%20it%2C%20deep%20navy%20mesas%20on%20the%20horizon%2C%20warm%20amber%20dust%20in%20the%20air%2C%20cinematic%20western%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-wasteland-banner&orientation=landscape",
    synopsis: "荒原上最后一班邮路上，年迈信使要送出一封改变整个小镇命运的信。八百公里，一场沙暴，还有一直在后面跟着他的人。",
    director: "Daniel Ross",
    cast: ["Hank Miller", "June Carter", "Owen Blake"],
    duration: "119 分钟",
    tagline: "一封信，能走多远。",
    heat: "3.6 万人正在看",
  },
  {
    id: "m009",
    title: "逐浪者",
    type: "电影",
    year: 2025,
    region: "澳大利亚",
    genres: ["运动", "励志"],
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20sports%20poster%20artwork%20of%20a%20surfer%20riding%20a%20huge%20turquoise%20wave%20at%20sunrise%2C%20deep%20navy%20ocean%20and%20warm%20amber%20sky%2C%20spray%20backlit%20by%20sun%2C%20dramatic%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-waverider-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Endless%20ocean%20horizon%20at%20sunrise%20with%20a%20single%20surfer%20paddling%20out%2C%20deep%20navy%20water%20and%20warm%20amber%20light%20on%20the%20swell%2C%20cinematic%20wide%20shot%2C%20misty%20sea%20spray%2C%20no%20text&width=1600&height=900&seq=movie-waverider-banner&orientation=landscape",
    synopsis: "失去左腿的少年冲浪者用三年时间重新站上浪尖，他要挑战的不只是海浪，还有所有人替他划定的那条线。",
    director: "Liam Brooks",
    cast: ["Jay Turner", "Ella Moore", "Sam Quinn"],
    duration: "107 分钟",
    tagline: "浪每次都会回来，你也可以。",
    heat: "8.3 万人正在看",
  },
  {
    id: "m010",
    title: "第七号档案",
    type: "电影",
    year: 2024,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%20artwork%20of%20a%20dim%20archive%20room%20with%20stacked%20files%20and%20a%20single%20desk%20lamp%20casting%20warm%20amber%20light%2C%20deep%20navy%20shadows%2C%20dust%20in%20the%20air%2C%20cinematic%20unease%2C%20no%20text&width=600&height=900&seq=movie-file07-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Long%20narrow%20archive%20corridor%20at%20night%20with%20endless%20shelves%20receding%20into%20dark%20navy%20shadow%2C%20one%20warm%20amber%20lamp%20at%20the%20far%20end%2C%20dusty%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-file07-banner&orientation=landscape",
    synopsis: "档案管理员在一批待销毁的旧卷宗里发现了第七号档案，里面详细记录着一场尚未发生的案件，包括他自己的死亡时间。",
    director: "정우진",
    cast: ["박서준", "김하늘", "이도현"],
    duration: "115 分钟",
    tagline: "有些档案，不该被打开。",
    heat: "10.2 万人正在看",
  },
  {
    id: "m011",
    title: "山海之间",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20artwork%20of%20a%20small%20hillside%20village%20house%20between%20mountains%20and%20sea%20at%20dawn%2C%20soft%20amber%20sunrise%2C%20deep%20navy%20mountain%20silhouettes%2C%20gentle%20mist%2C%20painterly%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-mountainsea-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Coastal%20mountain%20village%20at%20dawn%20with%20terraced%20fields%20and%20a%20calm%20sea%20beyond%2C%20soft%20amber%20sunlight%20over%20deep%20navy%20ridges%2C%20drifting%20mist%2C%20cinematic%20wide%20landscape%2C%20no%20text&width=1600&height=900&seq=movie-mountainsea-banner&orientation=landscape",
    synopsis: "父亲去世后，在城市打拼的女儿回到山海之间的小村处理老屋，却在旧物里重新认识了那个沉默了一辈子的男人。",
    director: "林淮",
    cast: ["何芷", "程国立", "苏晚"],
    duration: "124 分钟",
    tagline: "我们都在山海之间长大。",
    heat: "6.9 万人正在看",
  },
  {
    id: "m012",
    title: "霓虹夜行",
    type: "电影",
    year: 2025,
    region: "日本",
    genres: ["科幻", "动画"],
    rating: 9,
    cover: "https://readdy.ai/api/search-image?query=Anime%20science%20fiction%20poster%20artwork%20of%20a%20girl%20in%20a%20raincoat%20standing%20in%20a%20futuristic%20neon%20city%20street%20at%20night%2C%20deep%20navy%20sky%20and%20warm%20amber%20signage%20reflections%20in%20puddles%2C%20hand%20painted%20anime%20film%20style%2C%20no%20text&width=600&height=900&seq=movie-neonnight-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Futuristic%20anime%20city%20street%20at%20night%20seen%20from%20above%2C%20dense%20buildings%20and%20glowing%20warm%20amber%20signs%20against%20deep%20navy%20sky%2C%20rain%20and%20reflections%2C%20hand%20painted%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=movie-neonnight-banner&orientation=landscape",
    synopsis: "在永远不熄灯的未来都市里，一名跑腿少女接到委托：把一个没有名字的记忆送到城市边缘。沿途她遇见了所有被这座城市遗忘的人。",
    director: "新井悠",
    cast: ["花村凛", "佐仓透", "宫本澪"],
    duration: "108 分钟",
    tagline: "灯不会熄，人总要回家。",
    heat: "11.6 万人正在看",
  },
  {
    id: "m013",
    title: "铁幕黎明",
    type: "电影",
    year: 2022,
    region: "俄罗斯",
    genres: ["战争", "历史"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=War%20drama%20poster%20artwork%20of%20soldiers%20silhouetted%20against%20a%20cold%20dawn%20sky%20with%20snow%20falling%2C%20deep%20navy%20tones%20and%20faint%20warm%20amber%20horizon%2C%20smoke%20and%20bare%20trees%2C%20cinematic%20historical%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-ironcurtain-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Snow%20covered%20winter%20battlefield%20at%20dawn%20with%20bare%20trees%20and%20distant%20smoke%2C%20cold%20deep%20navy%20light%20with%20a%20thin%20warm%20amber%20horizon%2C%20cinematic%20historical%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-ironcurtain-banner&orientation=landscape",
    synopsis: "1942 年的严冬，一支翻译小队被派往前线，他们的任务不是开枪，而是让两个互不信任的阵营听懂彼此。",
    director: "Ivan Petrov",
    cast: ["Alexei Moroz", "Nadia Volkova", "Sergei Lan"],
    duration: "137 分钟",
    tagline: "语言，是最后一道防线。",
    heat: "4.1 万人正在看",
  },
  {
    id: "m014",
    title: "屋顶上的鲸",
    type: "电影",
    year: 2024,
    region: "法国",
    genres: ["奇幻", "动画"],
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20animated%20poster%20artwork%20of%20a%20giant%20whale%20floating%20above%20Paris%20rooftops%20at%20dusk%2C%20warm%20amber%20sky%20and%20deep%20navy%20clouds%2C%20a%20small%20child%20on%20a%20chimney%20looking%20up%2C%20hand%20painted%20illustration%20style%2C%20no%20text&width=600&height=900&seq=movie-roofwhale-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dreamy%20Parisian%20rooftop%20skyline%20at%20dusk%20with%20a%20enormous%20whale%20drifting%20through%20warm%20amber%20clouds%20above%20deep%20navy%20rooftops%2C%20tiny%20child%20figure%2C%20hand%20painted%20animated%20film%20background%2C%20no%20text&width=1600&height=900&seq=movie-roofwhale-banner&orientation=landscape",
    synopsis: "一个失去声音的小女孩在屋顶遇见了一头迷路的鲸，她决定带着它穿过整座城市，去找回家的那片海。",
    director: "Émile Roux",
    cast: ["Léa Martin", "Hugo Bernard"],
    duration: "96 分钟",
    tagline: "城市之上，还有一片海。",
    heat: "9.3 万人正在看",
  },
  {
    id: "m015",
    title: "逐梦绿茵",
    type: "电影",
    year: 2023,
    region: "西班牙",
    genres: ["运动", "喜剧"],
    rating: 8.1,
    cover: "https://readdy.ai/api/search-image?query=Uplifting%20sports%20comedy%20poster%20artwork%20of%20a%20young%20football%20player%20kicking%20a%20ball%20on%20a%20dusty%20neighborhood%20pitch%20at%20sunset%2C%20warm%20amber%20light%20flare%2C%20deep%20navy%20sky%2C%20joyful%20cinematic%20energy%2C%20no%20text&width=600&height=900&seq=movie-greenfield-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Small%20neighborhood%20football%20pitch%20at%20sunset%20with%20kids%20playing%20and%20warm%20amber%20dust%20light%2C%20deep%20navy%20evening%20sky%2C%20cinematic%20wide%20shot%2C%20energetic%20and%20hopeful%2C%20no%20text&width=1600&height=900&seq=movie-greenfield-banner&orientation=landscape",
    synopsis: "被降级的小镇球队只剩下七个球员和一位临时教练，他们要在这个赛季证明，热爱不需要预算。",
    director: "Diego Alvarez",
    cast: ["Marco Ruiz", "Lucia Vega", "Pablo Sanz"],
    duration: "101 分钟",
    tagline: "没有观众，也要进球。",
    heat: "5.2 万人正在看",
  },
  {
    id: "m016",
    title: "静默证词",
    type: "电影",
    year: 2025,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Tense%20legal%20drama%20poster%20artwork%20of%20a%20young%20lawyer%20standing%20alone%20in%20an%20empty%20courtroom%2C%20shafts%20of%20warm%20amber%20light%20through%20tall%20windows%2C%20deep%20navy%20shadows%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-silentproof-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Empty%20courtroom%20interior%20with%20wooden%20benches%20and%20tall%20windows%20casting%20warm%20amber%20light%20across%20deep%20navy%20shadows%2C%20cinematic%20wide%20shot%2C%20quiet%20dramatic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-silentproof-banner&orientation=landscape",
    synopsis: "一名聋人女孩成为一起密室案的唯一目击者，新手律师必须在开庭前学会真正听懂她的证词。",
    director: "程未",
    cast: ["沈砚", "南栀", "邵川"],
    duration: "122 分钟",
    tagline: "沉默，也是一种陈述。",
    heat: "7.1 万人正在看",
  },
  {
    id: "m017",
    title: "沙丘孤旅",
    type: "电影",
    year: 2024,
    region: "美国",
    genres: ["科幻", "剧情"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20poster%20artwork%20of%20a%20traveler%20in%20a%20flowing%20cloak%20walking%20across%20towering%20sand%20dunes%20under%20a%20huge%20amber%20sun%2C%20deep%20navy%20shadows%20on%20the%20sand%2C%20minimal%20dramatic%20composition%2C%20cinematic%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-dunetrip-17&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20rolling%20sand%20dunes%20under%20a%20huge%20amber%20sun%20with%20a%20tiny%20cloaked%20traveler%20silhouette%2C%20deep%20navy%20shadows%20in%20the%20troughs%2C%20sweeping%20cinematic%20science%20fiction%20landscape%2C%20no%20text&width=1600&height=900&seq=movie-dunetrip-banner&orientation=landscape",
    synopsis: "资源枯竭的星球上，最后一位水源勘测员踏上穿越沙海的旅程，他带着的不是设备，而是全城人的名字。",
    director: "Ryan Wolf",
    cast: ["Adam Pace", "Nora Bell", "Leo Grant"],
    duration: "146 分钟",
    tagline: "沙会记住每一个走过的人。",
    heat: "13.2 万人正在看",
  },
  {
    id: "m018",
    title: "南方来信",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "文艺"],
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20art%20house%20poster%20artwork%20of%20a%20woman%20reading%20a%20letter%20by%20a%20rainy%20window%20in%20a%20warm%20lit%20room%2C%20deep%20navy%20dusk%20outside%2C%20amber%20lamp%20glow%2C%20soft%20film%20grain%2C%20poetic%20composition%2C%20no%20text&width=600&height=900&seq=movie-southletter-18&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Quiet%20southern%20town%20street%20after%20rain%20at%20dusk%20with%20wet%20stone%20pavement%20reflecting%20warm%20amber%20lamps%20and%20deep%20navy%20sky%2C%20cinematic%20art%20house%20film%20still%2C%20no%20text&width=1600&height=900&seq=movie-southletter-banner&orientation=landscape",
    synopsis: "两封寄错地址的信，让两个素未谋面的陌生人在十年间保持着一种奇妙的联系，直到其中一封信再也寄不出去。",
    director: "闻笛",
    cast: ["叶子青", "季迟", "陆以南"],
    duration: "109 分钟",
    tagline: "信走到的地方，人还没到。",
    heat: "4.8 万人正在看",
  },
  {
    id: "m019",
    title: "惊蛰时刻",
    type: "电影",
    year: 2025,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=High%20energy%20action%20poster%20artwork%20of%20a%20martial%20artist%20mid%20motion%20in%20a%20dark%20warehouse%2C%20warm%20amber%20practical%20lights%20and%20deep%20navy%20shadows%2C%20motion%20blur%2C%20cinematic%20Hong%20Kong%20action%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-jingzhe-19&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Empty%20industrial%20warehouse%20at%20night%20lit%20by%20warm%20amber%20overhead%20lamps%20with%20deep%20navy%20darkness%20between%20pools%20of%20light%2C%20cinematic%20action%20film%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-jingzhe-banner&orientation=landscape",
    synopsis: "蛰伏三年的卧底在惊蛰这天收到收网指令，可他必须先决定，是抓住目标，还是先救出被牵连的弟弟。",
    director: "陈立行",
    cast: ["冯燚", "苏琪", "高正"],
    duration: "113 分钟",
    tagline: "惊蛰一响，谁都藏不住。",
    heat: "10.8 万人正在看",
  },
  {
    id: "m020",
    title: "银河食客",
    type: "电影",
    year: 2024,
    region: "日本",
    genres: ["喜剧", "奇幻"],
    rating: 8,
    cover: "https://readdy.ai/api/search-image?query=Playful%20fantasy%20comedy%20poster%20artwork%20of%20a%20tiny%20space%20diner%20floating%20among%20stars%20with%20warm%20amber%20interior%20glow%2C%20deep%20navy%20space%20backdrop%2C%20whimsical%20anime%20illustration%20style%2C%20charming%20and%20detailed%2C%20no%20text&width=600&height=900&seq=movie-galaxyeater-20&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Charming%20tiny%20diner%20floating%20in%20deep%20navy%20space%20with%20warm%20amber%20windows%20glowing%2C%20stars%20and%20soft%20nebula%20around%2C%20whimsical%20animated%20film%20background%2C%20no%20text&width=1600&height=900&seq=movie-galaxyeater-banner&orientation=landscape",
    synopsis: "宇宙边缘有一家只开一晚的拉面店，老板接待的客人来自各个星系，他们带着各自的乡愁点同一碗面。",
    director: "石井健",
    cast: ["松本悠", "大野葵", "北村遥"],
    duration: "98 分钟",
    tagline: "宇宙再大，也要吃饭。",
    heat: "6.4 万人正在看",
  },
  {
    id: "m021",
    title: "深渊之光",
    type: "电影",
    year: 2023,
    region: "挪威",
    genres: ["惊悚", "冒险"],
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Tense%20survival%20thriller%20poster%20artwork%20of%20a%20climber%20hanging%20on%20a%20dark%20icy%20cliff%20face%20with%20a%20single%20warm%20amber%20headlamp%20beam%2C%20deep%20navy%20storm%20clouds%2C%20dramatic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=movie-abyslight-21&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20icy%20mountain%20crevasse%20under%20storm%20clouds%20with%20a%20thin%20warm%20amber%20light%20beam%20cutting%20through%20deep%20navy%20shadow%2C%20cinematic%20survival%20thriller%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-abyslight-banner&orientation=landscape",
    synopsis: "一支洞穴救援队在暴雨夜深入地下三百米，唯一的出口被洪水封住，而他们找到的光源，来自不该存在的地方。",
    director: "Sven Halden",
    cast: ["Ingrid Dahl", "Erik Lund", "Maja Sol"],
    duration: "106 分钟",
    tagline: "最深的黑，才看得见光。",
    heat: "3.9 万人正在看",
  },
  {
    id: "m022",
    title: "归途列车",
    type: "电影",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "公路"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Warm%20road%20movie%20poster%20artwork%20of%20an%20old%20green%20train%20crossing%20a%20vast%20plain%20at%20sunset%20seen%20from%20a%20distance%2C%20warm%20amber%20sky%20and%20deep%20navy%20land%20shadow%2C%20nostalgic%20cinematic%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-hometrain-22&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Old%20green%20train%20crossing%20an%20open%20plain%20at%20sunset%2C%20long%20warm%20amber%20light%20across%20the%20fields%20and%20deep%20navy%20horizon%2C%20nostalgic%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=movie-hometrain-banner&orientation=landscape",
    synopsis: "春运最后一班绿皮车上，五个陌生人的目的地各不相同，却在这趟二十二小时的旅程里，各自找到了回家的理由。",
    director: "韩宿",
    cast: ["杜一凡", "李知微", "方岩"],
    duration: "117 分钟",
    tagline: "回家的路，从来不短。",
    heat: "5.5 万人正在看",
  },
  {
    id: "m023",
    title: "极昼猎人",
    type: "电影",
    year: 2025,
    region: "加拿大",
    genres: ["犯罪", "惊悚"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Cold%20crime%20thriller%20poster%20artwork%20of%20a%20lone%20ranger%20silhouette%20against%20blinding%20arctic%20white%20and%20pale%20navy%20sky%2C%20warm%20amber%20jacket%20accent%2C%20minimal%20stark%20composition%2C%20cinematic%20film%20still%2C%20no%20text&width=600&height=900&seq=movie-polarhunter-23&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Stark%20arctic%20tundra%20under%20pale%20midnight%20sun%2C%20deep%20navy%20snow%20shadows%20and%20a%20distant%20tiny%20figure%20with%20warm%20amber%20jacket%2C%20cinematic%20wide%20shot%2C%20isolating%20atmosphere%2C%20no%20text&width=1600&height=900&seq=movie-polarhunter-banner&orientation=landscape",
    synopsis: "极昼的北方小镇发生第一起谋杀案，没有黑夜可以掩盖罪行，也没有人愿意承认自己看见了什么。",
    director: "Owen Blackwood",
    cast: ["Caleb Frost", "Nina Ray", "Tom Hale"],
    duration: "121 分钟",
    tagline: "太阳不落，秘密难藏。",
    heat: "7.4 万人正在看",
  },
  {
    id: "m024",
    title: "最后一幕",
    type: "电影",
    year: 2024,
    region: "意大利",
    genres: ["剧情", "悬疑"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Elegant%20drama%20mystery%20poster%20artwork%20of%20an%20empty%20vintage%20theater%20stage%20with%20a%20single%20warm%20amber%20spotlight%20and%20deep%20navy%20velvet%20curtain%20shadows%2C%20cinematic%20symmetry%2C%20no%20text&width=600&height=900&seq=movie-lastscene-24&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ornate%20old%20theater%20auditorium%20with%20deep%20navy%20velvet%20seats%20and%20a%20single%20warm%20amber%20spotlight%20on%20the%20empty%20stage%2C%20cinematic%20wide%20symmetrical%20shot%2C%20dust%20in%20the%20air%2C%20no%20text&width=1600&height=900&seq=movie-lastscene-banner&orientation=landscape",
    synopsis: "一位退休导演被邀请重排自己四十年前的成名作，排练过程中，剧中那场从未解释的死亡，开始在现实里重演。",
    director: "Luca Moretti",
    cast: ["Elena Ricci", "Marco Dini", "Sofia Gallo"],
    duration: "128 分钟",
    tagline: "戏演完了，真相才开场。",
    heat: "8.6 万人正在看",
  },
  {
    id: "t001",
    title: "城市边缘",
    type: "电视剧",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "悬疑"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Urban%20mystery%20series%20poster%20artwork%20of%20a%20young%20woman%20walking%20through%20a%20rain%20wet%20city%20overpass%20at%20night%2C%20warm%20amber%20streetlight%20and%20deep%20navy%20buildings%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=tv-cityedge-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20city%20overpass%20at%20night%20with%20rain%20reflecting%20warm%20amber%20streetlights%20against%20deep%20navy%20skyscrapers%2C%20cinematic%20wide%20urban%20shot%2C%20moody%20atmosphere%2C%20no%20text&width=1600&height=900&seq=tv-cityedge-banner&orientation=landscape",
    synopsis: "在城市更新项目的最后一片老街区里，社区记者与拆迁队长同时发现，这片待拆的房子藏着一桩被时间掩埋的旧案。",
    director: "许南",
    cast: ["周牧野", "叶清和", "林拾"],
    duration: "全 36 集",
    tagline: "城市向外长，有人被留在边缘。",
    featured: true,
    heat: "16.8 万人在追",
  },
  {
    id: "t002",
    title: "长安夜行录",
    type: "电视剧",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    rating: 9,
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20mystery%20series%20poster%20artwork%20of%20a%20hooded%20figure%20holding%20a%20lantern%20in%20a%20night%20market%20alley%2C%20warm%20amber%20lanterns%20and%20deep%20navy%20shadows%2C%20ornate%20architecture%2C%20cinematic%20historical%20mood%2C%20no%20text&width=600&height=900&seq=tv-changan-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20street%20at%20night%20with%20rows%20of%20warm%20amber%20lanterns%20and%20deep%20navy%20sky%2C%20ornate%20wooden%20architecture%20and%20mist%2C%20cinematic%20historical%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=tv-changan-banner&orientation=landscape",
    synopsis: "长安城的巡夜人每逢子时记录城中异事，一册无人认领的夜行录，把三个原本毫无交集的年轻人牵进了同一场迷局。",
    director: "沈墨白",
    cast: ["顾长风", "苏轻月", "陆知白", "温九"],
    duration: "全 40 集",
    tagline: "子时之后，长安另有一座城。",
    heat: "21.3 万人在追",
  },
  {
    id: "t003",
    title: "潮汐之下",
    type: "电视剧",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=Korean%20crime%20mystery%20series%20poster%20artwork%20of%20a%20detective%20standing%20on%20a%20dark%20tidal%20flat%20at%20dusk%2C%20deep%20navy%20mudflats%20and%20warm%20amber%20distant%20harbor%20lights%2C%20cinematic%20somber%20mood%2C%20no%20text&width=600&height=900&seq=tv-tidetown-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20tidal%20flat%20at%20dusk%20with%20shallow%20water%20reflections%2C%20distant%20harbor%20lights%20glowing%20warm%20amber%20against%20deep%20navy%20sky%2C%20cinematic%20Korean%20thriller%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=tv-tidetown-banner&orientation=landscape",
    synopsis: "潮水退去后，港口小城露出了二十年前沉没的汽车，车里的东西让整个小镇的平静随之退潮。",
    director: "김민수",
    cast: ["이서진", "한지민", "박정우"],
    duration: "全 16 集",
    tagline: "潮水退了，秘密留下。",
    heat: "18.4 万人在追",
  },
  {
    id: "t004",
    title: "海岛诊所",
    type: "电视剧",
    year: 2023,
    region: "日本",
    genres: ["医疗", "剧情"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Warm%20medical%20drama%20series%20poster%20artwork%20of%20a%20small%20island%20clinic%20at%20sunrise%20with%20a%20doctor%20standing%20at%20the%20doorway%2C%20warm%20amber%20light%20and%20deep%20navy%20sea%20behind%2C%20gentle%20cinematic%20tone%2C%20no%20text&width=600&height=900&seq=tv-islandclinic-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Small%20island%20clinic%20by%20a%20calm%20sea%20at%20sunrise%2C%20warm%20amber%20light%20on%20wooden%20buildings%20and%20deep%20navy%20water%2C%20cinematic%20gentle%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=tv-islandclinic-banner&orientation=landscape",
    synopsis: "被调离大医院的外科医生来到只有三百人的海岛上，在这里，他第一次有时间把每个病人当作一个完整的人来了解。",
    director: "中野航",
    cast: ["佐藤亮", "石原理沙", "高桥彻"],
    duration: "全 10 集",
    tagline: "小岛上，没有小病。",
    heat: "9.6 万人在追",
  },
  {
    id: "t005",
    title: "双面律师",
    type: "电视剧",
    year: 2024,
    region: "美国",
    genres: ["律政", "剧情"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Legal%20drama%20series%20poster%20artwork%20of%20a%20lawyer%20standing%20in%20a%20glass%20office%20corridor%20at%20night%2C%20warm%20amber%20interior%20light%20against%20deep%20navy%20city%20darkness%2C%20cinematic%20corporate%20thriller%20mood%2C%20no%20text&width=600&height=900&seq=tv-duallawyer-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20glass%20office%20tower%20corridor%20at%20night%20with%20warm%20amber%20lighting%20and%20deep%20navy%20city%20skyline%20outside%20the%20windows%2C%20cinematic%20legal%20drama%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=tv-duallawyer-banner&orientation=landscape",
    synopsis: "一位同时替控辩双方做顾问的律师，在接手一桩商业巨案后发现自己服务过的两个客户，正在为同一个真相互相撕咬。",
    director: "Grace Lin",
    cast: ["Daniel Shaw", "Rachel Ford", "Miles Chen"],
    duration: "全 12 集",
    tagline: "法庭上，没有一面是干净的。",
    heat: "8.9 万人在追",
  },
  {
    id: "t006",
    title: "山海食堂",
    type: "电视剧",
    year: 2025,
    region: "中国大陆",
    genres: ["美食", "治愈"],
    rating: 8.5,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20food%20drama%20series%20poster%20artwork%20of%20a%20small%20rustic%20kitchen%20at%20night%20with%20steaming%20dishes%20on%20a%20wooden%20table%2C%20warm%20amber%20lamp%20light%20and%20deep%20navy%20window%20darkness%2C%20appetizing%20cinematic%20detail%2C%20no%20text&width=600&height=900&seq=tv-mountainkitchen-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Rustic%20village%20kitchen%20at%20night%20with%20warm%20amber%20lantern%20light%2C%20steaming%20bowls%20on%20a%20wooden%20table%20and%20deep%20navy%20mountain%20darkness%20outside%2C%20cozy%20cinematic%20food%20shot%2C%20no%20text&width=1600&height=900&seq=tv-mountainkitchen-banner&orientation=landscape",
    synopsis: "山路尽头的小食堂只在傍晚开门，老板用一道菜换一个故事，来的客人都带着还没说完的话。",
    director: "黎川",
    cast: ["储夏", "闻川", "陶一"],
    duration: "全 24 集",
    tagline: "一碗热汤，接得住所有疲惫。",
    heat: "11.2 万人在追",
  },
  {
    id: "t007",
    title: "时区之外",
    type: "电视剧",
    year: 2023,
    region: "英国",
    genres: ["科幻", "悬疑"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Science%20fiction%20mystery%20series%20poster%20artwork%20of%20a%20woman%20standing%20in%20an%20airport%20terminal%20with%20multiple%20clock%20faces%2C%20cold%20deep%20navy%20tones%20with%20warm%20amber%20clock%20glow%2C%20eerie%20symmetrical%20composition%2C%20no%20text&width=600&height=900&seq=tv-timezone-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Empty%20airport%20terminal%20at%20night%20with%20rows%20of%20clock%20faces%20glowing%20warm%20amber%20against%20deep%20navy%20windows%2C%20long%20perspective%2C%20eerie%20cinematic%20science%20fiction%20mood%2C%20no%20text&width=1600&height=900&seq=tv-timezone-banner&orientation=landscape",
    synopsis: "希思罗机场的失物招领处收到一只不属于任何时区的手表，而接触过它的人，都开始在同一天里反复醒来。",
    director: "Oliver Hayes",
    cast: ["Emma Hart", "Liam Doyle", "Sophie Kane"],
    duration: "全 8 集",
    tagline: "时间没有丢，是你走错了。",
    heat: "7.7 万人在追",
  },
  {
    id: "t008",
    title: "少年逐风",
    type: "电视剧",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "运动"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Youth%20sports%20series%20poster%20artwork%20of%20a%20teenage%20cyclist%20racing%20through%20a%20coastal%20road%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20and%20deep%20navy%20sea%2C%20dynamic%20motion%2C%20cinematic%20energy%2C%20no%20text&width=600&height=900&seq=tv-youngrider-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Coastal%20road%20at%20golden%20hour%20with%20a%20group%20of%20young%20cyclists%20racing%20in%20silhouette%2C%20warm%20amber%20light%20on%20the%20water%20and%20deep%20navy%20distant%20hills%2C%20cinematic%20wide%20sports%20shot%2C%20no%20text&width=1600&height=900&seq=tv-youngrider-banner&orientation=landscape",
    synopsis: "县城中学的自行车队没有专业装备，却想赢下省赛。少年们用一辆辆旧车，骑出了自己的夏天。",
    director: "程昭",
    cast: ["季夏", "许野", "梁木"],
    duration: "全 32 集",
    tagline: "风是往前的，人也一样。",
    heat: "10.5 万人在追",
  },
  {
    id: "t009",
    title: "北纬四十度",
    type: "电视剧",
    year: 2022,
    region: "法国",
    genres: ["剧情", "冒险"],
    rating: 8.3,
    cover: "https://readdy.ai/api/search-image?query=Adventure%20drama%20series%20poster%20artwork%20of%20a%20traveler%20standing%20on%20a%20windswept%20mountain%20ridge%20at%20dusk%2C%20deep%20navy%20clouds%20and%20warm%20amber%20horizon%20glow%2C%20cinematic%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=tv-latitude40-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Windswept%20mountain%20ridge%20at%20dusk%20with%20layered%20deep%20navy%20peaks%20and%20a%20warm%20amber%20horizon%2C%20tiny%20traveler%20silhouette%20on%20the%20ridge%2C%20cinematic%20wide%20landscape%2C%20no%20text&width=1600&height=900&seq=tv-latitude40-banner&orientation=landscape",
    synopsis: "一位地质学家沿着北纬四十度线徒步三千公里，一路上遇见的人，逐渐拼出他失踪多年的父亲的轨迹。",
    director: "Camille Laurent",
    cast: ["Julien Roy", "Anaïs Petit"],
    duration: "全 6 集",
    tagline: "一条纬度，一段未完成的旅程。",
    heat: "4.3 万人在追",
  },
  {
    id: "t010",
    title: "星港迷案",
    type: "电视剧",
    year: 2025,
    region: "美国",
    genres: ["科幻", "犯罪"],
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=Science%20fiction%20crime%20series%20poster%20artwork%20of%20a%20detective%20in%20a%20futuristic%20spaceport%20hangar%20at%20night%2C%20warm%20amber%20industrial%20lights%20and%20deep%20navy%20shadows%2C%20cinematic%20noir%20science%20fiction%20mood%2C%20no%20text&width=600&height=900&seq=tv-starport-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Futuristic%20spaceport%20hangar%20at%20night%20with%20cargo%20ships%20and%20warm%20amber%20industrial%20lighting%20cutting%20through%20deep%20navy%20shadow%2C%20cinematic%20wide%20science%20fiction%20shot%2C%20no%20text&width=1600&height=900&seq=tv-starport-banner&orientation=landscape",
    synopsis: "轨道港的警探调查一名货运员的失踪，线索指向一艘从未登记过的货船，也指向他自己被删除的那段记忆。",
    director: "Alex Turner",
    cast: ["Chris Nolan", "Zoe Park", "Marc Diaz"],
    duration: "全 10 集",
    tagline: "在星港，没有人真的离开。",
    heat: "12.9 万人在追",
  },
  {
    id: "v001",
    title: "荒野厨房",
    type: "综艺",
    year: 2025,
    region: "中国大陆",
    genres: ["真人秀", "美食"],
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20reality%20show%20poster%20artwork%20of%20a%20campfire%20cooking%20scene%20in%20a%20mountain%20valley%20at%20dusk%2C%20warm%20amber%20firelight%20and%20deep%20navy%20mountains%2C%20hanging%20pots%20and%20steam%2C%20cinematic%20warm%20atmosphere%2C%20no%20text&width=600&height=900&seq=variety-wildkitchen-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Mountain%20valley%20campsite%20at%20dusk%20with%20a%20warm%20amber%20campfire%20and%20cooking%20setup%2C%20deep%20navy%20ridges%20and%20drifting%20smoke%2C%20cinematic%20outdoor%20lifestyle%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=variety-wildkitchen-banner&orientation=landscape",
    synopsis: "六位嘉宾带着一口锅深入荒野，用当地食材完成一日三餐，在有限的条件下把日子过出滋味。",
    director: "野外制作组",
    cast: ["常驻嘉宾 6 人"],
    duration: "全 12 期",
    tagline: "没有外卖，也能吃得很好。",
    heat: "6.8 万人在看",
  },
  {
    id: "v002",
    title: "舞台之上",
    type: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    rating: 8.4,
    cover: "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20artwork%20of%20a%20singer%20silhouette%20on%20a%20grand%20stage%20under%20a%20single%20warm%20amber%20spotlight%2C%20deep%20navy%20audience%20darkness%2C%20cinematic%20concert%20atmosphere%2C%20no%20text&width=600&height=900&seq=variety-stageon-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20a%20warm%20amber%20spotlight%20beam%20and%20deep%20navy%20silhouettes%20of%20an%20audience%2C%20haze%20and%20light%20beams%2C%20cinematic%20wide%20concert%20shot%2C%20no%20text&width=1600&height=900&seq=variety-stageon-banner&orientation=landscape",
    synopsis: "不同风格的歌手在同一座舞台上重新编排经典曲目，每一期都由现场观众决定谁能留到最后。",
    director: "音乐现场组",
    cast: ["竞演歌手 12 组"],
    duration: "全 10 期",
    tagline: "灯光亮起，只剩声音。",
    heat: "9.1 万人在看",
  },
  {
    id: "v003",
    title: "漫游城市",
    type: "综艺",
    year: 2023,
    region: "中国大陆",
    genres: ["旅行", "纪实"],
    rating: 8.2,
    cover: "https://readdy.ai/api/search-image?query=Travel%20documentary%20show%20poster%20artwork%20of%20a%20narrow%20old%20town%20street%20at%20dusk%20with%20warm%20amber%20shop%20lights%20and%20deep%20navy%20sky%2C%20bicycles%20and%20hanging%20signs%2C%20cinematic%20documentary%20mood%2C%20no%20text&width=600&height=900&seq=variety-citywalk-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Old%20town%20street%20at%20dusk%20with%20warm%20amber%20shop%20lights%20reflecting%20on%20wet%20stone%20and%20deep%20navy%20sky%2C%20cinematic%20travel%20documentary%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=variety-citywalk-banner&orientation=landscape",
    synopsis: "不赶景点，只走街巷。主持人用一天时间，把一座城市从清晨逛到深夜，聊的都是本地人的日常。",
    director: "城市漫游组",
    cast: ["主持人 2 人"],
    duration: "全 8 期",
    tagline: "慢一点，城市才开口。",
    heat: "4.6 万人在看",
  },
  {
    id: "v004",
    title: "解谜之夜",
    type: "综艺",
    year: 2025,
    region: "韩国",
    genres: ["推理", "真人秀"],
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=Mystery%20game%20show%20poster%20artwork%20of%20a%20dim%20mansion%20hallway%20with%20an%20old%20clock%20and%20warm%20amber%20candlelight%2C%20deep%20navy%20shadows%2C%20suspenseful%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=variety-mysterynight-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dim%20mansion%20hallway%20at%20night%20with%20warm%20amber%20candlelight%20and%20long%20deep%20navy%20shadows%2C%20ornate%20doors%20and%20old%20clock%2C%20cinematic%20mystery%20show%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=variety-mysterynight-banner&orientation=landscape",
    synopsis: "六位玩家被关进一栋会变化的宅邸，每解开一个谜题，就离真相更近一步，也离彼此更远一点。",
    director: "추리 제작팀",
    cast: ["玩家 6 人"],
    duration: "全 8 期",
    tagline: "答案就在你身后。",
    heat: "7.9 万人在看",
  },
];

export type WatchApp = {
  id: string;
  name: string;
  icon: string;
  category: "免费" | "会员制" | "部分付费";
  platforms: string[];
  size: string;
  version: string;
  updated: string;
  rating: number;
  downloads: string;
  summary: string;
  description: string;
  features: string[];
  changelog: { version: string; date: string; note: string }[];
  reviews: { user: string; date: string; score: number; text: string }[];
};

export const watchApps: WatchApp[] = [
  {
    id: "a001",
    name: "星河影库",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20stylized%20film%20reel%20inside%20a%20rounded%20square%2C%20deep%20navy%20blue%20gradient%20background%20with%20warm%20amber%20accent%20glow%2C%20clean%20modern%20vector%20look%2C%20no%20text&width=400&height=400&seq=app-starfilm-icon&orientation=squarish",
    category: "免费",
    platforms: ["iOS", "Android", "TV"],
    size: "68 MB",
    version: "v4.8.2",
    updated: "2026-09-28",
    rating: 4.8,
    downloads: "2,860 万次",
    summary: "片库更新最快的综合看片工具，支持 4K 与倍速播放。",
    description: "星河影库是一款面向普通影迷的综合影视播放工具，聚合电影、电视剧、综艺、纪录片等多种内容，支持 4K 高清播放、倍速与离线缓存。界面简洁，分类清晰，适合长时间浏览与追剧使用。",
    features: ["4K 高清播放，支持 HDR", "离线缓存与断点续播", "智能片单与追剧提醒", "支持投屏到电视与投影"],
    changelog: [
      { version: "v4.8.2", date: "2026-09-28", note: "优化长剧集加载速度，修复投屏偶发中断问题。" },
      { version: "v4.7.0", date: "2026-07-12", note: "新增倍速记忆功能，片单支持自定义排序。" },
      { version: "v4.5.1", date: "2026-04-03", note: "全新播放器界面，字幕大小与色调可调。" },
    ],
    reviews: [
      { user: "影迷小李", date: "2026-09-30", score: 5, text: "片库真的全，老片新片都能找到，播放很稳。" },
      { user: "周末观影", date: "2026-09-12", score: 4, text: "界面干净，就是缓存大文件时进度提示可以再清楚一点。" },
      { user: "追剧的猫", date: "2026-08-21", score: 5, text: "追剧提醒挺实用，不会错过更新。" },
    ],
  },
  {
    id: "a002",
    name: "看片盒子",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20rounded%20play%20button%20inside%20a%20box%20shape%2C%20deep%20navy%20background%20with%20warm%20amber%20gradient%20edge%2C%20modern%20clean%20vector%20style%2C%20no%20text&width=400&height=400&seq=app-watchbox-icon&orientation=squarish",
    category: "免费",
    platforms: ["Android", "TV"],
    size: "42 MB",
    version: "v3.2.6",
    updated: "2026-09-15",
    rating: 4.6,
    downloads: "1,940 万次",
    summary: "轻量级播放器，适合电视盒子与大屏使用。",
    description: "看片盒子专为大屏场景设计，安装包小、启动快，遥控器操作逻辑清晰。支持本地视频播放与网络片源管理，适合放在客厅电视盒子里长期使用。",
    features: ["遥控器专属操作布局", "本地与网络片源统一管理", "低配置设备流畅播放", "自动匹配字幕"],
    changelog: [
      { version: "v3.2.6", date: "2026-09-15", note: "提升大屏列表滚动流畅度。" },
      { version: "v3.1.0", date: "2026-06-08", note: "新增字幕自动匹配与手动校正。" },
    ],
    reviews: [
      { user: "客厅常客", date: "2026-09-18", score: 5, text: "装在电视盒子上很轻，遥控器操作舒服。" },
      { user: "老王", date: "2026-08-30", score: 4, text: "本地片源识别的字幕很准，偶尔需要手动调。" },
    ],
  },
  {
    id: "a003",
    name: "云端影院",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20cloud%20shape%20merged%20with%20a%20cinema%20screen%2C%20deep%20navy%20gradient%20background%20with%20soft%20warm%20amber%20highlight%2C%20modern%20flat%20vector%2C%20no%20text&width=400&height=400&seq=app-cloudcinema-icon&orientation=squarish",
    category: "部分付费",
    platforms: ["iOS", "Android", "Web"],
    size: "96 MB",
    version: "v5.0.4",
    updated: "2026-10-02",
    rating: 4.7,
    downloads: "1,260 万次",
    summary: "云同步观看进度，多设备无缝续看。",
    description: "云端影院主打跨设备体验，登录后观看记录、片单与收藏会自动同步，手机看到一半可以在平板上继续。基础片库免费，部分新片需要单独解锁。",
    features: ["跨设备进度云同步", "个性化片单推荐", "支持网页端直接观看", "家庭成员独立档案"],
    changelog: [
      { version: "v5.0.4", date: "2026-10-02", note: "网页端支持画中画，同步速度提升。" },
      { version: "v4.9.0", date: "2026-08-19", note: "新增家庭成员档案，推荐更精准。" },
    ],
    reviews: [
      { user: "通勤族阿哲", date: "2026-10-05", score: 5, text: "地铁上看一半，回家平板接着看，太方便了。" },
      { user: "Mia", date: "2026-09-22", score: 4, text: "同步基本没出过错，希望新增片源再快一点。" },
    ],
  },
  {
    id: "a004",
    name: "剧集星球",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20ringed%20planet%20made%20from%20a%20film%20strip%20circle%2C%20deep%20navy%20space%20background%20with%20warm%20amber%20ring%20glow%2C%20clean%20modern%20vector%20style%2C%20no%20text&width=400&height=400&seq=app-seriesplanet-icon&orientation=squarish",
    category: "免费",
    platforms: ["iOS", "Android"],
    size: "74 MB",
    version: "v2.9.1",
    updated: "2026-08-26",
    rating: 4.5,
    downloads: "980 万次",
    summary: "专为追剧打造，更新提醒与季集管理很省心。",
    description: "剧集星球只做剧集，按季、集整理得清清楚楚，更新提醒与观看进度一目了然。适合同时追多部剧的用户，首页会按你的观看节奏排序。",
    features: ["季集结构清晰", "多剧同时追更提醒", "自动跳过片头片尾", "剧集评分与短评"],
    changelog: [
      { version: "v2.9.1", date: "2026-08-26", note: "修复部分剧集集数识别错误。" },
      { version: "v2.8.0", date: "2026-05-14", note: "新增自动跳过片头片尾设置。" },
    ],
    reviews: [
      { user: "追更达人", date: "2026-08-28", score: 5, text: "一次追六部剧也不乱，集数从来没对错过。" },
      { user: "小林", date: "2026-08-02", score: 4, text: "跳过片头很准，个别老剧需要手动设置。" },
    ],
  },
  {
    id: "a005",
    name: "极光播放器",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20an%20aurora%20wave%20over%20a%20play%20triangle%2C%20deep%20navy%20background%20with%20warm%20amber%20and%20teal%20gradient%20light%2C%20modern%20clean%20vector%20style%2C%20no%20text&width=400&height=400&seq=app-auroraplayer-icon&orientation=squarish",
    category: "免费",
    platforms: ["Android", "Windows", "Mac"],
    size: "58 MB",
    version: "v6.1.0",
    updated: "2026-09-06",
    rating: 4.6,
    downloads: "1,530 万次",
    summary: "全能格式播放器，本地片源与字幕支持最全。",
    description: "极光播放器支持几乎所有主流视频与音频格式，字幕、音轨、画面比例都能精细调整。适合有本地片库的用户，桌面端与安卓端体验一致。",
    features: ["全格式硬解支持", "外挂字幕与多音轨切换", "画面增强与音频均衡器", "支持局域网文件播放"],
    changelog: [
      { version: "v6.1.0", date: "2026-09-06", note: "新增 HDR 画面增强，改善老片清晰度。" },
      { version: "v6.0.2", date: "2026-07-01", note: "修复部分字幕编码乱码问题。" },
    ],
    reviews: [
      { user: "本地片库党", date: "2026-09-09", score: 5, text: "什么格式都能放，字幕调节选项很全。" },
      { user: "老周", date: "2026-08-16", score: 4, text: "桌面端很稳，希望移动端也能同步设置。" },
    ],
  },
  {
    id: "a006",
    name: "夜色影视",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20crescent%20moon%20combined%20with%20a%20film%20frame%2C%20deep%20navy%20gradient%20background%20with%20warm%20amber%20thin%20outline%2C%20modern%20minimal%20vector%2C%20no%20text&width=400&height=400&seq=app-nightfilm-icon&orientation=squarish",
    category: "会员制",
    platforms: ["iOS", "Android", "Web"],
    size: "88 MB",
    version: "v3.6.3",
    updated: "2026-07-30",
    rating: 4.4,
    downloads: "760 万次",
    summary: "夜间观影模式做得很细，护眼又省电。",
    description: "夜色影视以夜间观影体验为核心，提供低蓝光模式、暖色字幕与音量平衡，长时间看片眼睛负担更小。会员制提供稳定的高清线路。",
    features: ["专业夜间护眼模式", "音量自动平衡", "高清稳定线路", "支持定时关闭"],
    changelog: [
      { version: "v3.6.3", date: "2026-07-30", note: "优化夜间模式色温曲线。" },
      { version: "v3.5.0", date: "2026-05-22", note: "新增定时关闭与睡眠提醒。" },
    ],
    reviews: [
      { user: "夜猫子", date: "2026-08-05", score: 5, text: "晚上看片眼睛舒服很多，色温调得刚好。" },
      { user: "阿伟", date: "2026-06-18", score: 3, text: "护眼确实好，但会员价格略高。" },
    ],
  },
  {
    id: "a007",
    name: "片场直通车",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20clapperboard%20angled%20inside%20a%20rounded%20square%2C%20deep%20navy%20background%20with%20warm%20amber%20diagonal%20accent%2C%20modern%20clean%20vector%2C%20no%20text&width=400&height=400&seq=app-setexpress-icon&orientation=squarish",
    category: "免费",
    platforms: ["iOS", "Android"],
    size: "52 MB",
    version: "v1.8.5",
    updated: "2026-09-19",
    rating: 4.3,
    downloads: "640 万次",
    summary: "新片速递与预告集中看，适合挑片。",
    description: "片场直通车把最新预告、上映信息与短评聚合在一起，帮你快速判断一部片子值不值得看。内置的片单功能可以和朋友一起协作挑选。",
    features: ["新片预告聚合", "上映日历提醒", "协作片单", "短评与评分汇总"],
    changelog: [
      { version: "v1.8.5", date: "2026-09-19", note: "新增上映日历订阅。" },
      { version: "v1.7.0", date: "2026-06-30", note: "片单支持邀请好友共同编辑。" },
    ],
    reviews: [
      { user: "挑片困难户", date: "2026-09-21", score: 5, text: "先看预告再决定，省了不少时间。" },
      { user: "阿树", date: "2026-07-25", score: 4, text: "片单协作很好用，信息更新也及时。" },
    ],
  },
  {
    id: "a008",
    name: "弹幕放映室",
    icon: "https://readdy.ai/api/search-image?query=Minimal%20app%20icon%20design%20of%20a%20speech%20bubble%20containing%20a%20play%20symbol%2C%20deep%20navy%20background%20with%20warm%20amber%20bubble%20outline%2C%20modern%20flat%20vector%20style%2C%20no%20text&width=400&height=400&seq=app-danmaku-icon&orientation=squarish",
    category: "免费",
    platforms: ["Android", "Web", "TV"],
    size: "63 MB",
    version: "v4.2.8",
    updated: "2026-10-08",
    rating: 4.5,
    downloads: "1,120 万次",
    summary: "边看边聊，弹幕氛围最热闹的观影工具。",
    description: "弹幕放映室支持实时弹幕、一起看房间与话题讨论，看片不只是看片，更像一场线上的集体放映。弹幕样式与屏蔽规则都可以自定义。",
    features: ["实时弹幕与一起看房间", "弹幕样式自定义", "关键词屏蔽", "支持投屏同步弹幕"],
    changelog: [
      { version: "v4.2.8", date: "2026-10-08", note: "一起看房间延迟优化，支持 50 人同看。" },
      { version: "v4.1.0", date: "2026-08-11", note: "新增弹幕透明度与字号调节。" },
    ],
    reviews: [
      { user: "弹幕护体", date: "2026-10-10", score: 5, text: "和朋友远程一起看，边看边聊太快乐了。" },
      { user: "小苏", date: "2026-09-01", score: 4, text: "弹幕设置很自由，人多的时候偶尔会卡。" },
    ],
  },
];

export const regions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国", "法国", "其他"];
export const years = ["全部", "2025", "2024", "2023", "2022"];
export const sortOptions = ["最新上线", "评分最高", "人气最热"];

export const genreMap: Record<MovieType, string[]> = {
  电影: ["全部", "悬疑", "剧情", "犯罪", "动作", "科幻", "爱情", "动画", "历史", "喜剧"],
  电视剧: ["全部", "都市", "古装", "悬疑", "犯罪", "医疗", "科幻", "青春", "美食", "律政"],
  综艺: ["全部", "真人秀", "美食", "音乐", "旅行", "推理", "纪实"],
};

export const getMovieById = (id: string) => movies.find((item) => item.id === id);
export const getAppById = (id: string) => watchApps.find((item) => item.id === id);